<template>
	<div :class="['information-container']" @mouseenter="hover" @mouseleave="hoverOut">
		<img :class="[{'light' : iconTheme === 'light'}]" :src="require('@/drc/assets/icons/information.svg')" alt="i">
		<div class="information-tooltip" v-if="isOpened">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: "Information",
	props: {
		iconTheme: {
			type: String,
			required: false,
			default: 'dark'
		}
	},
	data() {
		return {
			isOpened: false
		}
	},
	methods: {
		hover() {
			this.isOpened = true
		},
		hoverOut() {
			this.isOpened = false
		}
	}
}
</script>

<style lang="scss">
.hint-read-more {
	p {
		color: black;
		font-size: 14px;
		font-family: Roboto, serif;
		font-weight: 400;
		margin-left: 0;
		margin-right: 0;
		margin-top: 0;
		margin-bottom: 0;

		&.margin-bottom {
			margin-bottom: 10px;
		}
	}

	a {
		color: #D99C15;
		cursor: pointer;

		&:hover {
			text-decoration: underline;
		}
	}
}
</style>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.information-container {
	height: 22px;
	max-height: 22px;
	max-width: 22px;
	width: 22px;
	overflow: visible;
	position: relative;

	img {
		width: 22px;
		height: 22px;
		min-width: 22px;
		position: relative;
		cursor: pointer;

		&.light {
			filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(1%) hue-rotate(265deg) brightness(111%) contrast(101%);
		}
	}

	.information-tooltip {
		margin-top: 10px;
		position: relative;
		z-index: 1;
		min-height: fit-content;
		min-width: 20vw;
		background: white;
		border-radius: 4px;
		color: black;
		padding: 10px;
		font-size: 14px;
		font-family: Roboto, serif;
		font-weight: 400;
		width: 100%;
		line-height: 18px;
		border: 1px solid #E5E5EA;
		box-shadow: 0px 25px 21px -5px #0000001A;
		box-shadow: 0px 2px 25px -5px #00000029;
		left: -10px;

		&:before {
			content: '';
			display: inline-block;
			width: 0;
			height: 0;
			border-left: 10px solid transparent;
			border-right: 10px solid transparent;
			border-bottom: 10px solid white;
			position: absolute;
			top: -10px;
			left: 10px;
			z-index: 1;
		}

		@media (max-width: $tablet) {
			min-width: 40vw;
		}

		@media (max-width: $mobile) {
			position: absolute;
			right: -10px;
			min-width: calc(100% + 185px);
			left: unset;

			&:before {
				left: unset;
				right: 10px;
			}
		}
	}
}
</style>
